export default __webpack_public_path__ + "aa56a69cc489975461eb5b60684f43a9.svg";